

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const rp727 = {
    label: "Religion Register",
    pageLabel: "Religion Register",
    starting: true,
    url: "rp727",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Branch",
            name: "",
            description: "Enter Parent Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Branch",
            name: "ParentBranch",
            description: "Parent Branch"
          }, 
          {
            inputType: "showdata",
            data: "Main Branch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Only Staff",
            name: "OnlyStaff",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product Type",
            label: "Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Only Director",
            name: "OnlyDirector",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product",
            label: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Address",
            name: "PrintAddress",
            description: ""
          },        
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As on Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "dateFrom",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print NPA Status",
            name: "PrintNPAStatus",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account Number From To",
            name: "",
            description: "Enter Account Number From To" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Account NumberFrom",
            name: "AccountNumberFrom",
            description: "Enter Account Number From"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Account Number To",
            name: "AccountNumberTo",
            description: "Enter Account Number To"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
           
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Opening Date From-To",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "OpeningdateFrom",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "OpeningdateTo",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          }, 
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Order By Religion",
            name: "OrderByReligion",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Sanction Amount From-To",
            name: "",
            description: "Enter Sanction Amount From-To" 
          }, 
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Sanction Amount From",
            name: "SanctionAmountFrom",
            description: "Enter AmountFrom"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "AmountTo",
            name: "SanctionAmountTo",
            description: "Enter Amount To"
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
               children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Detail Balance",
            name: "Detailalance",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "NPA Status",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "NPAStatus",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Balance < % Sanction",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Balance < % Sanction",
            name: "BalanceSanction",
            description: ""
          }, 
                  
    ]
}
export default rp727;